export default {
	sec_01: {
		title: {
			one: 'シンプル',
			two: 'な要請',
		},
		desc: {
			one: '友達と家族に通知なしで',
			two: '暗号資産を要請することができます',
		},
		btn: {
			one: '暗号資産を要請する',
			two: 'アプリダウンロード',
		},
	},
	sec_09: {
		title: {
			one: '快適な資産要請',
			two: 'サービス',
		},
		one: {
			desc: {
				one: '快適で使いやすく手軽にできる、',
				two: '双方向の要請メッセージサービス',
			},
		},
	},
	sec_03: {
		one: {
			title: {
				one: '手軽な',
				two: '無料要請サービス',
			},
			desc: {
				one: '友人に簡単に送金を要請して待つと',
				two: '自動的に入金されます。',
			},
		},
		two: {
			title: {
				one: 'シンプルな設定',
			},
			desc: {
				one: '友人がJP WORLD PAYアカウントをお持ちではなくても、',
				two: '数分で会員登録するだけ完了です。',
			},
		},
		three: {
			title: {
				one: 'JP WORLD PAYでユーザーを選択して',
				two: '要請金額を入力してください。',
			},
			desc: {
				one: '即座にJP WORLD PAY資産要請リンクを作って、',
				two: '毎日でも暗号資産を受け取る事が容易になります。',
			},
			btn: {
				one: 'JP WORLD PAYリンクの作成',
			},
		},
	},
	sec_05: {
		title: '給与を支給することも簡単にできます。',
		desc: {
			one: 'アプリを開き、支払い受け取るを選択してください。',
		},
	},
};
